<template>
  <div>
    <GmapMarker
      v-for="(point, index) in points"
      :key="index"
      :position="position(point.location)"
      :clickable="true"
      :draggable="false"
      :icon="icon"
      :label="label(index)"
      :zIndex="zIndex(points.length, index)"
    >
      <GmapPolyline
        v-if="points[index + 1]"
        :path="path(point.location, points[index + 1].location)"
        :options="options"
      />
    </GmapMarker>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { gmapApi } from 'vue2-google-maps'

export default {
  methods: {
    position: function (location) {
      return {
        lat: location.latitude,
        lng: location.longitude
      }
    },
    path: function (location, nextLocation) {
      return [
        { lat: location.latitude, lng: location.longitude },
        { lat: nextLocation.latitude, lng: nextLocation.longitude }
      ]
    },
    // NOTE: 最初の目的地を手前にもってくる
    zIndex: function (length, index) {
      return 5 + length - index
    },
    label: function (index) {
      return {
        text: String(index + 1),
        color: '#FFFFFF'
      }
    },
    fitBoundsPlan: function () {
      var latLngBounds = new this.google.maps.LatLngBounds();
      for (var i = 0; i < this.points.length; i++) {
        latLngBounds.extend(new this.google.maps.LatLng(this.points[i].location.latitude, this.points[i].location.longitude))
      }
      this.map.fitBounds(latLngBounds, 10)
    }
  },
  data () {
    return {
      points: []
    }
  },
  computed: {
    ...mapGetters({
      destinations: 'destinations/getAll',
      departureStation: 'destinations/getDepatureStation',
      arrivalStation: 'destinations/getArrivalStation',
      from: 'map/getFrom',
      map: 'googleMap/getMap',
      courseDetail: 'courses/getCourseDetail'
    }),
    google: gmapApi,
    icon: function () {
      if (this.google) {
        return {
          fillColor: "#1998c8",
          fillOpacity: 1,
          path: this.google.maps.SymbolPath.CIRCLE,
          scale: 16,
          strokeColor: "#000000",
          strokeWeight: 1.0
        }
      } else {
        return {}
      }
    },
    options: function () {
      var headArrow = {
        fillOpacity: 1,
        fillColor: "#444444",
        strokeColor: "#444444",
        strokeOpacity: 1
      };
      if (this.google) {
        headArrow.path = this.google.maps.SymbolPath.FORWARD_CLOSED_ARROW
      }
      var icon_symbol =  [{
        icon: headArrow,
        offset: '100%',
        repeat: '150px'
      }];
      return {
        strokeColor: "#444444",
        strokeOpacity: 0.8,
        strokeWeight: 3,
        icons: icon_symbol
      }
    }
  },
  watch: {
    from: function (val) {
      if (val.name == 'plan' || val.name == 'editPlan' || val.name =='newPlan') {
        this.points.splice(0)
        this.points.push(this.departureStation)
        this.destinations.forEach(d => this.points.push(d))
        this.points.push(this.arrivalStation)
      } else if (val.name == 'courses') {
        this.points.splice(0)
        this.$store.dispatch('stations/searchFromStation', this.courseDetail.departure_code)
          .then(() => {
            this.$store.dispatch('stations/searchToStation', this.courseDetail.arrival_code)
              .then(() => {
                const fromStation = this.$store.getters['stations/getFromStation']
                const toStation = this.$store.getters['stations/getToStation']
                this.points.push({
                  location:{
                    latitude: parseFloat(fromStation.GeoPoint.lati_d),
                    longitude: parseFloat(fromStation.GeoPoint.longi_d)
                  }
                })
                this.courseDetail.places.forEach(p => this.points.push(p))
                this.points.push({
                  location:{
                    latitude: parseFloat(toStation.GeoPoint.lati_d),
                    longitude: parseFloat(toStation.GeoPoint.longi_d)
                  }
                })
              })
          })
      }
    }
  }
}
</script>
